// import { useState } from "react";
// import {
//   Search,
//   PersonFill,
//   Briefcase,
//   Envelope,
//   Link45deg,
//   GeoAlt,
//   Calendar,
// } from "react-bootstrap-icons";
// import "./LinkedInSearch.css";
// import axios from "axios";

// interface ProfileData {
//   name: string;
//   profilePic: string;
//   headline: string;
//   location: string;
//   about: string;
//   experience: {
//     title: string;
//     company: string;
//     duration: string;
//     description: string;
//   }[];
//   education: {
//     school: string;
//     degree: string;
//     field: string;
//     year: string;
//   }[];
//   skills: string[];
//   profileUrl: string;
// }

// export default function LinkedInSearch() {
//   const [profileUrl, setProfileUrl] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [profile, setProfile] = useState<ProfileData | null>(null);



//   const fetchProfile = async (e: React.FormEvent) => {
//     e.preventDefault();

//     if (!profileUrl) {
//       setError("Please enter a LinkedIn profile URL");
//       return;
//     }

//     setIsLoading(true);
//     setError("");

//     try {
//       const response = await axios.post(
//         "https://api.apify.com/v2/acts/dev_fusion~linkedin-profile-scraper/run-sync-get-dataset-items?format=json",
//         {
//           profileUrls: [profileUrl],
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer apify_api_UXJvo4U3EUmE8fozVoYLhw14mt8Zy64oCEz8`,
//           },
//         }
//       );

//       // Apify returns an array
//       const data = response.data[0];

//       // ✅ Map to your UI structure
//       const mappedProfile: ProfileData = {
//         name:
//           data.fullName ||
//           `${data.firstName || ""} ${data.lastName || ""}`.trim(),
//         profilePic: data.profilePicture || "",
//         headline: data.headline || "",
//         location: data.addressWithCountry || "",
//         about: data.about || "",
//         experience: (data.experiences || []).map((exp: any) => ({
//           title: exp.title || "",
//           company: exp.subtitle || exp.companyName || "",
//           duration: exp.caption || "",
//           description: exp.subComponents?.[0]?.description?.join("\n") || "",
//         })),
//         education: (data.educations || []).map((edu: any) => ({
//           school: edu.title || "",
//           degree: "", // not provided in response
//           field: "", // not provided in response
//           year: edu.caption || "",
//         })),
//         skills:
//           (data.skills || []).map((skill: any) => skill.name || skill) || [],
//         profileUrl: data.linkedinUrl || profileUrl,
//       };

//       setProfile(mappedProfile);
//     } catch (err: any) {
//       console.error(
//         "Error fetching profile:",
//         err.response?.data || err.message
//       );
//       setError("Failed to fetch profile. Please try again later.");
//     } finally {
//       setIsLoading(false);
//     }
//   };


import { useState } from "react";
import {
  Search,
  PersonFill,
  Briefcase,
  Envelope,
  Link45deg,
  GeoAlt,
  Calendar,
} from "react-bootstrap-icons";
import "./LinkedInSearch.css";
import axios from "axios";

interface ProfileData {
  name: string;
  profilePic: string;
  headline: string;
  location: string;
  about: string;
  experience: {
    title: string;
    company: string;
    duration: string;
    description: string;
  }[];
  education: {
    school: string;
    degree: string;
    field: string;
    year: string;
  }[];
  skills: string[];
  profileUrl: string;
}

const extractDescription = (descArray: any[]): string => {
  if (!Array.isArray(descArray)) return "";
  return descArray
    .map((d: any) => {
      if (typeof d === "string") return d;
      if (d && typeof d === "object" && d.text) return d.text;
      return "";
    })
    .filter(Boolean)
    .join("\n");
};

export default function LinkedInSearch() {
  const [profileUrl, setProfileUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [profile, setProfile] = useState<ProfileData | null>(null);





//     const fetchProfile = async (e: React.FormEvent) => {
//  e.preventDefault();
//  if (!profileUrl) {
//     setError('Please enter a LinkedIn profile URL');
//       return;
//     }

//     setIsLoading(true);
//     setError('');

//     try {
//       // In a real app, you would make an API call to your backend
//     // which would then use a service like Proxycurl to fetch the LinkedIn data
//     // This is a mock implementation
//     await new Promise(resolve => setTimeout(resolve, 1500));

//     // Mock data - replace with actual API call
//      const mockProfile: ProfileData = {
//        name: 'John Doe',
//         profilePic: 'https://via.placeholder.com/150',
//        headline: 'Senior Product Designer at TechCorp',
//        location: 'San Francisco Bay Area',
//        about: 'Passionate about creating intuitive user experiences and beautiful interfaces. Specializing in user research, wireframing, and prototyping.',
//        experience: [
//          {
//            title: 'Senior Product Designer',
//            company: 'TechCorp',
//            duration: '2020 - Present',
//            description: 'Leading the design of enterprise products and design systems.'
//          },
//          {
//            title: 'Product Designer',
//            company: 'DesignHub',
//            duration: '2018 - 2020',
//            description: 'Designed and shipped multiple features for the core product.'
//          }
//        ],
//        education: [
//          {
//            school: 'Stanford University',
//            degree: 'Master of Design',
//            field: 'Human-Computer Interaction',
//            year: '2018'
//          },
//          {
//            school: 'Rhode Island School of Design',
//            degree: 'Bachelor of Fine Arts',
//            field: 'Graphic Design',
//            year: '2016'
//          }
//        ],
//        skills: [
//          'UI/UX Design', 'User Research', 'Prototyping', 'Figma',
//          'Sketch', 'Adobe Creative Suite', 'HTML/CSS', 'Design Systems'
//        ],
//        profileUrl: 'https://www.linkedin.com/in/johndoe'
//      };

//      setProfile(mockProfile);
//    } catch (err) {
//      console.error('Error fetching profile:', err);
//      setError('Failed to fetch profile. Please try again.');
//    } finally {
//      setIsLoading(false);
//    }
//  };



  const fetchProfile = async (e: React.FormEvent) => {
   e.preventDefault();

    if (!profileUrl) {
      setError("Please enter a LinkedIn profile URL");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
    
      const response = await axios.post(
        "https://api.apify.com/v2/acts/dev_fusion~linkedin-profile-scraper/run-sync-get-dataset-items?format=json",
        {
          profileUrls: [profileUrl],
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer apify_api_UXJvo4U3EUmE8fozVoYLhw14mt8Zy64oCEz8`,
          },
        }
      );

      // Apify returns an array
      const data = response.data[0];

      // Helper to extract description
      const getDescription = (subComp: any) => {
        if (subComp?.description) {
          return extractDescription(subComp.description);
        }
        return "";
      };

      // Flatten experiences
      const experiences: ProfileData["experience"] = [];
      (data.experiences || []).forEach((exp: any) => {
        if (exp.breakdown && exp.subComponents) {
          // Company-level with sub-positions
          const company = exp.title || "";
          exp.subComponents.forEach((sub: any) => {
            if (sub.title) {
              experiences.push({
                title: sub.title,
                company,
                duration: sub.caption || "",
                description: getDescription(sub),
              });
            }
          });
        } else {
          // Position-level
          experiences.push({
            title: exp.title || "",
            company: exp.subtitle || exp.companyName || "",
            duration: exp.caption || "",
            description: exp.subComponents?.[0]
              ? getDescription(exp.subComponents[0])
              : "",
          });
        }
      });

      // Map to your UI structure
      const mappedProfile: ProfileData = {
        name:
          data.fullName ||
          `${data.firstName || ""} ${data.lastName || ""}`.trim(),
        profilePic: data.profilePic || "",
        headline: data.headline || "",
        location: data.addressWithCountry || "",
        about: data.about || "",
        experience: experiences,
        education: (data.educations || []).map((edu: any) => ({
          school: edu.title || "",
          degree: edu.subtitle || "",
          field: "", // Can extract from description if needed
          year: edu.caption || "",
        })),
        skills:
          (data.skills || []).map((skill: any) => skill.title || "") || [],
        profileUrl: data.linkedinUrl || profileUrl,
      };

      setProfile(mappedProfile);
    } catch (err: any) {
      console.error(
        "Error fetching profile:",
        err.response?.data || err.message
      );
      setError("Failed to fetch profile. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="linkedin-search-container">
      <h1 className="linkedin-search-header">LinkedIn Profile Search</h1>

      <div className="search-form">
        <form onSubmit={fetchProfile}>
          <div className="form-group">
            <label htmlFor="linkedin-url" className="form-label">
              LinkedIn Profile URL
            </label>
            <div className="input-container">
              <div className="input-wrapper">
                <div className="input-icon">
                  <Link45deg
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
                <input
                  type="url"
                  name="linkedin-url"
                  id="linkedin-url"
                  className="input-field"
                  placeholder="https://www.linkedin.com/in/username"
                  value={profileUrl}
                  onChange={(e) => setProfileUrl(e.target.value)}
                  required
                />
              </div>
              <button
                type="submit"
                className="search-button"
                disabled={isLoading}
              >
                <Search className="h-5 w-5 text-gray-400" aria-hidden="true" />
                <span>{isLoading ? "Searching..." : "Search"}</span>
              </button>
            </div>
            <p className="helper-text">
              Enter a public LinkedIn profile URL to fetch details
            </p>
          </div>
        </form>

        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}
      </div>

      {isLoading && (
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
      )}

      {profile && !isLoading && (
        <div className="profile-card">
          {/* Profile Header */}
          <div className="profile-header">
            <div className="profile-avatar">
              <div className="avatar-wrapper">
                <div className="avatar">
                  {profile.profilePic ? (
                    <img
                      src={profile?.profilePic}
                      alt={`${profile.name}'s profile`}
                      className="h-12 w-12 rounded-full object-cover"
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: "9999px",
                      }}
                    />
                  ) : (
                    <PersonFill className="h-12 w-12 text-gray-400" />
                  )}
                </div>
              </div>
              <div className="profile-info">
                <h2 className="profile-name">{profile.name}</h2>
                <p className="profile-headline">{profile.headline}</p>
                <div className="profile-location">
                  <GeoAlt className="h-4 w-4" />
                  <span>{profile.location}</span>
                </div>
              </div>
            </div>
          </div>

          {/* About Section */}
          <div className="profile-section">
            <h3 className="section-title">About</h3>
            <div className="section-content">
              <p>{profile.about}</p>
            </div>
          </div>

          {/* Experience Section */}
          <div className="profile-section">
            <h3 className="section-title">Experience</h3>
            <div className="section-content">
              {profile.experience.map((exp, idx) => (
                <div key={idx} className="experience-item">
                  <h4 className="item-title">{exp.title}</h4>
                  <p className="item-company">{exp.company}</p>
                  <p className="item-duration">
                    <Calendar className="h-3.5 w-3.5" />
                    {exp.duration}
                  </p>
                  <p className="item-description">{exp.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Education Section */}
          <div className="profile-section">
            <h3 className="section-title">Education</h3>
            <div className="section-content">
              {profile.education.map((edu, idx) => (
                <div key={idx} className="education-item">
                  <h4 className="item-school">{edu.school}</h4>
                  {edu.degree && edu.field && (
                    <p className="item-field">
                      {edu.degree} in {edu.field}
                    </p>
                  )}
                  <p className="item-year">
                    <Calendar className="h-3.5 w-3.5" />
                    {edu.year}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Skills Section */}
          <div className="profile-section">
            <h3 className="section-title">Skills</h3>
            <div className="skills-container">
              {profile.skills.map((skill, idx) => (
                <span key={idx} className="skill-tag">
                  {skill}
                </span>
              ))}
            </div>
          </div>

          {/* Profile Link */}
          <div className="profile-footer">
            <a
              href={profile.profileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="profile-link"
            >
              View full profile on LinkedIn
              <svg
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
